<template>
  <v-content>
    <v-container
      class="fill-height"
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
        >
          <v-card class="elevation-12">
            <v-toolbar
              color="primary"
              dark
              flat
            >
              <v-toolbar-title>Kirjaudu sisään (v4 salasanallinen) {{login}} {{password}} </v-toolbar-title>
            </v-toolbar>
            <v-form @submit.prevent="tryLogin">
              <v-card-text>
                  <v-text-field
                  v-model="login"
                  label="Kirjautumistunnus"
                  name="login"
                  type="text"
                  outlined
                  />

                  <v-text-field
                  v-model="password"
                  label="Salasana"
                  name="password"
                  type="password"
                  outlined
                  />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                color="primary"
                large
                type="submit"
                >Kirjaudu</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import axios from "axios";
import store from "@/store"

export default {
  data() {
    return {
      login: '',
      password: '',
    }
  },
  methods: {
    tryLogin() {
      axios.post(
        'https://apiv4.kiuruvesi.net/auth', {},
        {
          headers: {
            "Authorization" : 'Basic ' + btoa(this.login + ':' + this.password),
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      .then((response) => {
        if (response.data.token || response.data.user ) {
          store.dispatch('saveUser', response.data.user);
          store.dispatch('saveToken', response.data.token);
        } else {
          alert('Sattui odottamaton virhe!');
        }
        this.$router.replace({ name: 'home' });
      })
      .catch(function (e) {
        alert(e)
      })
    }
  },
  mounted() {
    if (this.$store.getters.token) {
      this.$router.replace({ name: 'home' });
    }
  }
}
</script>